/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembershipPurchaseSessionCreatedResponse } from '../../models/membership-purchase-session-created-response';

export interface CreateMembershipRegistrationPurchaseSession$Params {
  membershipId: number;
}

export function createMembershipRegistrationPurchaseSession(http: HttpClient, rootUrl: string, params: CreateMembershipRegistrationPurchaseSession$Params, context?: HttpContext): Observable<StrictHttpResponse<MembershipPurchaseSessionCreatedResponse>> {
  const rb = new RequestBuilder(rootUrl, createMembershipRegistrationPurchaseSession.PATH, 'post');
  if (params) {
    rb.path('membershipId', params.membershipId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembershipPurchaseSessionCreatedResponse>;
    })
  );
}

createMembershipRegistrationPurchaseSession.PATH = '/api/memberships/{membershipId}/create-registration-session';
